import { createAllMarkers } from "./createAllMarkers";
import { styles } from "./map-style";
import { sideLinksClick } from "./side-links";
import { storeSearch } from "./store-search";
import { closestStore } from "./closest-store";
import { closeInfoWindow } from "./info-window";
import { repositionMap } from "./reposition-map";
import { infoWindow } from "./info-window";

function initMap(element, mapMarkers) {
  const $mapHolder = $(element);
  repositionMap($mapHolder);

  let map = new google.maps.Map($mapHolder[0], {
    zoom: 16,
    styles: styles,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false
  });

  createAllMarkers(map, mapMarkers);
  sideLinksClick(map);
  storeSearch(map);
  closestStore(map);
  closeInfoWindow(map);

  $(".store-results").on("click", "a", function() {
    const $this = $(this);
    infoWindow(map, $this.data("target"));
  });
}

module.exports = {
  initMap
};



// WEBPACK FOOTER //
// ../assets/js/map/init.js